import React from 'react';
import { connect } from "react-redux";
import { Badge, Typography, Divider, LinkList, LinkListItem, Button, Drawer } from "../../ecosystem";

const DrawerProxySelector = ({
    age,
    children,
    open,
    name,
    toggle,
    isAdult,
    onAddFamilyClick,
}) => {

    const puIsAdult = isAdult ? isAdult : age && age > 17 ? true : false;

    return <>
        <Drawer
            title="Select a Family Member"
            open={open}
            toggle={toggle}
        >
            <div className={"drawer-proxy-selector"}>
                <div className="drawer-proxy-selector__heading">
                    <Typography type="heading-05" color="$color-primary-a2">{name},</Typography>
                </div>

                <div className="drawer-proxy-selector__subheading">
                    <Typography type="heading-02" color="$color-primary-a2">Who would you like to view info for?</Typography>
                    <div className="divider-underline" />
                </div>
                <div className="proxy-selector__links">
                    {children}

                    {puIsAdult && onAddFamilyClick &&
                        <div className="drawer-proxy-selector__add-btn">
                            <Button
                                variant="secondary"
                                onClick={onAddFamilyClick}
                            >+Add or Grant Family Access</Button>
                        </div>
                    }
                </div>
            </div>
        </Drawer>
    </>

}

const mapStateToProps = (state) => {
    return {
        age: state.domain.age,
    }
}

export default connect(mapStateToProps)(DrawerProxySelector);
